import product_one_url from "@/assets/images/compare-devices/product_1.png";
import product_two_url from "@/assets/images/compare-devices/product_2.png";
import product_three_url from "@/assets/images/compare-devices/product_3.png";
import product_four_url from "@/assets/images/compare-devices/product_4.png";
import product_five_url from "@/assets/images/compare-devices/product_5.png";

export const devices = [
  {
    name: "Kirbi",
    img: product_one_url,
    installationType: "Plug-In",
    waterproof: "",
    canData: true,
    batteryPowered: false,
    iternalBatteryBackUp: true,
    driverBehavior: true,
    externalAntennaForOptimalReception: false,
    remoteFeatures: null,
    optionalDcConnector: null,
    sosButton: false,
    sharedLinkForRentalFleets: false,
    maintenanceReports: true,
  },
  {
    name: "Mini Pro",
    img: product_two_url,
    installationType: "Hard-wired",
    waterproof: "Water resistant",
    canData: false,
    batteryPowered: false,
    iternalBatteryBackUp: true,
    driverBehavior: true,
    externalAntennaForOptimalReception: false,
    remoteFeatures: "Ignition/fuel kill",
    optionalDcConnector: null,
    sosButton: false,
    sharedLinkForRentalFleets: false,
    maintenanceReports: false,
  },
  {
    name: "HydroLTE",
    img: product_three_url,
    installationType: "Hard-wired",
    waterproof: "Water resistant",
    canData: false,
    batteryPowered: false,
    iternalBatteryBackUp: true,
    driverBehavior: true,
    externalAntennaForOptimalReception: false,
    remoteFeatures: "Ignition/fuel kill, alarm/horn activation",
    optionalDcConnector: "Text",
    sosButton: true,
    sharedLinkForRentalFleets: false,
    maintenanceReports: false,
  },
  {
    name: "Dash T11",
    img: product_four_url,
    installationType: "Hard-wired",
    waterproof: null,
    canData: true,
    batteryPowered: false,
    iternalBatteryBackUp: true,
    driverBehavior: true,
    externalAntennaForOptimalReception: true,
    remoteFeatures: null,
    optionalDcConnector: null,
    sosButton: true,
    sharedLinkForRentalFleets: true,
    maintenanceReports: true,
  },
  {
    name: "Dash T11",
    img: product_five_url,
    installationType: "Magnet Surface mount or concealed/Hidden",
    waterproof: null,
    canData: true,
    batteryPowered: true,
    iternalBatteryBackUp: false,
    driverBehavior: false,
    externalAntennaForOptimalReception: false,
    remoteFeatures: null,
    optionalDcConnector: null,
    sosButton: false,
    sharedLinkForRentalFleets: false,
    maintenanceReports: false,
  },
];

export const ROWS = {
  img: "img",
  name: "name",
  button: "button",
};

export const deviceRows = [ROWS.img, ROWS.name, ROWS.button];
